import { HttpClient } from '@angular/common/http';
import BigNumber from 'bignumber.js';
import { tap } from 'rxjs/operators';
import { Base } from '../../../base';

export class Funds extends Base {
  constructor(protected httpClient: HttpClient, private parent: string) {
    super(httpClient, `${parent}/funds`);
  }

  query(params?: any) {
    return this.api.query(params).pipe(
      tap((json) => json.funds.forEach((record: any) => this.processRecord(record)))
    );
  }

  getTotal() {
    return this.api.get('total').pipe(
      tap((json) => this.processRecord(json))
    );
  }

  private processRecord(record: any) {
    record.fee = new BigNumber(record.fee || 0).fromDecimal();
    record.gasFee = new BigNumber(record.gasFee || 0).fromDecimal();
    record.amount = new BigNumber(record.amount || 0).fromDecimal().plus(record.fee);
    record.shares = new BigNumber(record.shares || 0).fromDecimal();
    record.price = record.shares.eq(0) ? null : record.amount.div(record.shares);
  }
}
